import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import config from '../config';
import { useTranslation } from 'react-i18next';

const VerifyEmail = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('loading');
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    let isCalled = false;
  
    const token = searchParams.get('token');
    const email = searchParams.get('email');
  
    if (!token || !email || isCalled) {
      setStatus('invalid');
      return;
    }
  
    const verify = async () => {
      try {
        const res = await fetch(`${config.getApiUrl('auth/verify-email')}?token=${token}&email=${email}`);
        const data = await res.json();
        if (data.success) {
          setStatus('success');
          isCalled = true;
          setTimeout(() => navigate('/explorer'), 3000);
        } else {
          setStatus('error');
        }
      } catch (err) {
        setStatus('error');
      }
    };
  
    verify();
  }, [searchParams, navigate]);
  
  return (
    <div className="max-w-md mx-auto p-6 text-center">
      {status === 'loading' && <p>{t('emailVerification.verifying', 'Verifying your email...')}</p>}
      {status === 'success' && (
        <div>
          <h2 className="text-green-600 font-bold text-xl mb-2">{t('emailVerification.success', 'Email verified!')}</h2>
          <p>{t('emailVerification.redirecting', 'You’ll be redirected shortly...')}</p>
        </div>
      )}
      {status === 'error' && (
        <div>
          <h2 className="text-red-600 font-bold text-xl mb-2">{t('emailVerification.failed', 'Verification failed')}</h2>
          <p>{t('emailVerification.retry', 'Please check your link or request a new verification email.')}</p>
        </div>
      )}
      {status === 'invalid' && (
        <div>
          <h2 className="text-red-600 font-bold text-xl mb-2">{t('emailVerification.invalid', 'Invalid link')}</h2>
          <p>{t('emailVerification.retry', 'Please check your link or request a new verification email.')}</p>
        </div>
      )}
    </div>
  );
};

export default VerifyEmail;
